// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3X4K_r8TwLmudeFd6KlRjW","spaceLeft":"_12nuxairk1va2JL6KoBTxF","spaceBoth":"_2piVkdhqF1vzVjizafSo5A","spaceRight":"_1zZquug8Jnc_qmvcPmx8MG","table":"_2BrzncsHiPm90HPZyQwDuB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisMarketHistory.scss
// module id = 1214
// module chunks = 0